define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/locale",
	"csi/page",
	"csi/widget/MessageDialog",
	"csi/types",
	"csi/xml"
], function(declare, Controller, locale, page, MessageDialog, types, xml) {

	return declare(Controller, {
		preProcess: function() {
			// summary: confirm start if necessary
			var parent = this.getParent();
			var wbs = (parent == null) ? null : this.m_cache.getNode(parent.WBS);
			if (wbs && wbs.AutoStartOnPlannedStart) {
				this.confirmAction({});
			} else {
				this.inherited(arguments);
			}
		},

		confirmAction: function(/*Object*/params) {
			//summary: customize buttons
			if(!params.buttons){
				params.buttons = [MessageDialog.BUTTON_START_IMMEDIATELY + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
			}
			this.inherited(arguments);
		},
		
		displayError() {
			if (this._errorCode === "SRV_ERR_WBS_WBS_ILLEGAL_STATE") {
				const message = locale.resource("WbsIllegalState");
				const title = locale.resource("RefreshBrowserTitle");
				const buttons = [MessageDialog.BUTTON_REFRESH + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
				this.confirmAction({message, buttons, title});
			} else {
				this.inherited(arguments);
			}
		},

		onConfirm: function(/*String*/key) {
			if (key == MessageDialog.BUTTON_START_IMMEDIATELY) {
				Controller.prototype.preProcess.call(this);
			} else if (key === MessageDialog.BUTTON_REFRESH) {
				page.refreshRootView();
				this.postProcess();
			} else {
				this.postProcess();
			}
		},

		toWriter: function() {
			// summary: let the server know when midnight is in the client's time zone;
			// it will use that time to set start dates
			var call = this.inherited(arguments);
			call.addParameter("Date", xml.ATTR_TIME, types.getDateTime());
			return call;
		},
	});
});